import ProductCard from "./ProductCard";
import ScrollReveal from "./ScrollReveal";
import { Link } from "react-router-dom";

const FlashSaleProducts = ({ products }) => {
  if (!products || products.length === 0) return null;

  // Products are already sorted by discount and limited to 8 by the backend
  const flashProducts = products;

  return (
    <section className="bg-red-50/50 dark:bg-slate-900/40 py-6 sm:py-12 border-y border-red-100 dark:border-slate-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <ScrollReveal variants="fade-up" distance={30}>
          <div className="flex flex-col items-center mb-4 sm:mb-10 text-center">
            <div className="flex items-center gap-2 sm:gap-3 mb-2">
              <span className="text-xl sm:text-3xl animate-bounce">🔥</span>
              <h2 className="text-2xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-orange-500 dark:from-red-500 dark:to-orange-400 tracking-tight drop-shadow-sm">
                FLASH SALE HÔM NAY
              </h2>
              <span className="text-xl sm:text-3xl animate-bounce">🔥</span>
            </div>
            <div className="h-1 w-20 sm:h-1.5 sm:w-32 bg-gradient-to-r from-red-600 to-orange-500 dark:from-red-500 dark:to-orange-400 rounded-full mb-3 sm:mb-4 shadow-sm"></div>
            <p className="text-red-600 dark:text-red-400 font-bold text-[10px] sm:text-lg uppercase tracking-wider">
              Săn ngay deal cực sốc - Số lượng có hạn!
            </p>
          </div>
        </ScrollReveal>

        {/* Product Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
          {flashProducts.map((product, i) => (
            <ScrollReveal
              key={product._id}
              variants="fade-up"
              delay={i * 0.1}
              distance={20}
            >
              <div className="relative">
                {/* Optional Decoration */}
                <div className="absolute -top-2 -right-2 z-20 bg-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full animate-pulse shadow-lg uppercase">
                  Hot
                </div>
                <ProductCard product={product} />
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Catchy Footer Link (Optional) */}
        <div className="mt-8 sm:mt-12 text-center">
          <Link
            to="/products"
            className="inline-block bg-gradient-to-r from-red-600 to-orange-500 text-white px-6 py-2 sm:px-8 sm:py-3 rounded-full font-bold text-xs sm:text-base hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            XEM TẤT CẢ KHUYẾN MÃI
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FlashSaleProducts;
